import { z } from 'zod';
import { DISCOUNT_KIND, type DiscountKind } from './discountKind';
import {
  DISCOUNT_PERCENTAGE_MAX,
  DISCOUNT_PERCENTAGE_MIN,
  isValidDiscountAmount,
  isValidDiscountPercentage
} from './discountValueInputs';

export type PromotionDealValidationValues = {
  discountKind: DiscountKind;
  discountAmount: number | null;
  discountPercentage: number | null;
  appliesToAllProducts: boolean;
  filterByProducts: boolean;
  filterByTags: boolean;
  salesItemIds: number[];
  salesItemTagIds: number[];
};

export const refinePromotionDealFields = (value: PromotionDealValidationValues, ctx: z.RefinementCtx): void => {
  if (value.discountKind === DISCOUNT_KIND.amount && !isValidDiscountAmount(value.discountAmount)) {
    ctx.addIssue({ code: 'custom', message: 'Enter a discount amount', path: ['discountAmount'] });
  }
  if (value.discountKind === DISCOUNT_KIND.percentage && !isValidDiscountPercentage(value.discountPercentage)) {
    ctx.addIssue({
      code: 'custom',
      message: `Enter a percentage between ${DISCOUNT_PERCENTAGE_MIN} and ${DISCOUNT_PERCENTAGE_MAX}`,
      path: ['discountPercentage']
    });
  }
  if (value.appliesToAllProducts) {
    return;
  }
  if (!value.filterByProducts && !value.filterByTags) {
    ctx.addIssue({
      code: 'custom',
      message: 'Pick products, tags, or all products',
      path: ['filterByProducts']
    });
    return;
  }
  if (value.filterByProducts && value.salesItemIds.length === 0) {
    ctx.addIssue({ code: 'custom', message: 'Pick at least one product', path: ['salesItemIds'] });
  }
  if (value.filterByTags && value.salesItemTagIds.length === 0) {
    ctx.addIssue({ code: 'custom', message: 'Pick at least one tag', path: ['salesItemTagIds'] });
  }
};
